"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var camelToKebab_1 = (0, tslib_1.__importDefault)(require("./camelToKebab"));
var generatedIds = new Map();
function getUniquePostfix(className) {
    if (generatedIds.has(className)) {
        var newID = generatedIds.get(className) + 1;
        generatedIds.set(className, newID);
        return "".concat(newID);
    }
    generatedIds.set(className, 0);
    return '';
}
function getUniqueId(classImportName) {
    var kebabName = (0, camelToKebab_1.default)(classImportName);
    return "".concat(kebabName).concat(getUniquePostfix(kebabName));
}
exports.default = getUniqueId;
//# sourceMappingURL=getUniqueId.js.map